<mat-form-field
  class="ccs-textarea"
  color="primary"
  [hideRequiredMarker]="true"
  [floatLabel]="floatLabel">
  <mat-label>{{ label }}</mat-label>
  <textarea
    matInput
    spellcheck="false"
    #autosize="cdkTextareaAutosize"
    cdkTextareaAutosize
    [cdkAutosizeMinRows]="autosizeMinRow"
    [cdkAutosizeMaxRows]="autosizeMaxRow"
    [formControl]="control"
    [appCanAutoFocus]="autofocus"
    [placeholder]="placeholder"
    [maxlength]="maxLength"
    (focus)="onFocus.emit($event)"
    (blur)="onBlur.emit($event)"
    (keydown)="onKeydown.emit($event)"
    (keyup)="onKeyup.emit($event)"
    (input)="onInput.emit($any($event))">
  </textarea>

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }

  <mat-error>
    {{ control.errors | errorMessage: errorMessages }}
  </mat-error>
</mat-form-field>
